const transform = {
  name: "transform",
  path: "/transform",
  title: "transform",
  description: "Utilities for controlling the CSS transform property.",
  value: {
    "transform": {
      "transform-none": "none"
    }
  },
  exampleData: [
    {
      example: {
        code: `<div class="skew-y-3 md:transform-none">
  <!-- ... -->
</div>`
      }
    }
  ],
  htmlData: [
    {
      title: "No transform",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">transform-none</code> to remove all transforms from an element.
      </p>
      <div class="flex gap-8 items-center justify-center">
        <div class="flex flex-col items-center">
          <span class="mb-3 text-xs text-color-gray-500">transform-none</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="skew-y-3 md:transform-none size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
      </div>
      `
    }
  ]
};

export default transform;
<div className="sr-only skew-y-3 md:transform-none"></div>